import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next';
import { useOfferTags } from 'cityads-v3/hooks/offers';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import muiTheme from 'cityads-v3/utils/muiTheme/darkTheme';
import { useOfferFiltersContext } from '../../OfferFilters.hooks';
import classes from './March8Banner.scss'

import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { TagWithVisible } from 'cityads-v3/types/tag';

export const BannerTags = [
  '8mar',
]

const buttonTheme = createTheme({
  palette: {
    primary: {
      main: '#D9322C'
    },
  },
})

export default function March8Banner(): JSX.Element {
  const { t } = useTranslation(['main']);
  const [tags] = useOfferTags() as [TagWithVisible[]]
  const offerFilters = useOfferFiltersContext()

  /** Если подразумевается несколько тегов для одного баннера. Выбираем первый попавшийся */
  const tagName = tags.filter(tag => BannerTags.includes(tag.code))[0]?.code

  const handleSelectTag = useCallback(() => {
    if (offerFilters.selectedFilters.fields.tags.value.includes(tagName)) {
      offerFilters.refresh()
    } else {
      offerFilters.selectedFilters.fields.tags.pushToArray(tagName)
      offerFilters.selectedFilters.handleSubmit()
    }
  }, [offerFilters, tagName])

  if (!tagName) {
    return null;
  }

  return (
    <MuiThemeProvider theme={muiTheme}>
      <div className={classes.mainContainer}>
        <div className={classes.container}>
          <div className={classes.text}>
            <Typography
              variant="h6"
              classes={{ root: classes.title }}
            >{t('march8.title')}</Typography>
            <Typography classes={{ root: classes.description }}>{t('march8.description')}</Typography>

            <MuiThemeProvider theme={buttonTheme}>
              <Button
                disableElevation
                color="primary"
                classes={{ root: classes.button }}
                onClick={handleSelectTag}
                variant="contained"
              >{t('march8.button')}</Button>
            </MuiThemeProvider>
          </div>
        </div>
      </div>
    </MuiThemeProvider>
  )
}
